"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundEstimationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const core_auth_1 = require("@deliverr/core-auth");
class InboundEstimationClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = { authEngine: core_auth_1.AuthEngine.COGNITO }) {
        var _a;
        const clientConfig = Object.assign(Object.assign({}, config), { baseURL: (_a = config.baseURL) !== null && _a !== void 0 ? _a : process.env.INBOUND_ESTIMATION_SERVICE_URL, authEngine: config.authEngine });
        if (!clientConfig.baseURL) {
            commons_logs_1.log.warn("baseURL is not configured");
        }
        super(clientConfig);
    }
    async getShipmentEta(shipmentId) {
        return this.get(`/v1/geteta/${shipmentId}`);
    }
}
exports.InboundEstimationClient = InboundEstimationClient;
exports.default = InboundEstimationClient;
//# sourceMappingURL=InboundEstimationClient.js.map